(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const initMobileFooter = (root) => {
      if (!root || root.dataset.simtionFooterReady === 'true') return;
      root.dataset.simtionFooterReady = 'true';
      const toggles = [...root.querySelectorAll('[data-simtion-footer-toggle]')];
      const panels = [...root.querySelectorAll('[data-simtion-footer-panel]')];

      const setState = (toggle, open) => {
        const panel = root.querySelector('#' + toggle.getAttribute('aria-controls'));
        if (!panel) return;
        toggle.setAttribute('aria-expanded', String(open));
        panel.setAttribute('aria-hidden', String(!open));
        panel.classList.toggle('is-open', open);
        panel.inert = !open;
      };

      panels.forEach((panel) => {
        panel.inert = true;
      });

      toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const open = toggle.getAttribute('aria-expanded') === 'true';
          toggles.forEach((item) => setState(item, false));
          if (!open) setState(toggle, true);
        });
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-simtion-mobile-footer]').forEach(initMobileFooter);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
